import { useTranslation } from "react-i18next";
import {
  CloseOutlined,
  CopyOutlined,
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
  SaveOutlined,
  UploadOutlined
} from "@ant-design/icons";
import {
  Button,
  Form,
  GetProp,
  message,
  Tooltip,
  Typography,
  Upload,
  UploadProps
} from "antd";
import { FormInstance } from "antd/lib";
import { get, isEmpty } from "lodash";
import { MouseEvent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL_V2 } from "../../../../config/api/configApiv2";
import { routesConfig } from "../../../../config/routes";
import { addStudentToCourseByChoose, addStudentToCourseByExcel, downloadTemplateExportStudentToCourse, getListStudentAddEnrolled, importStudentToCourse, postCourseSearch } from "../../../../service/course-construct";
import { useAuthStore } from "../../../../stores/stores";
import { handleExportExcel } from "../../../../utils/functionUltils";
import CustomCard from "../../../custom-card/CustomCard";
import AddStudentToCourseDrawer from "../../../drawer/add-student-to-course";
import FormItemInput from "../../../form-input/FormInput";
import ImportStudentToCourseModal from "../../../modal/import-student-to-course-modal/ImportStudentToCourseModal";
import ListStudentAddedToCourseModal from "../../../modal/import-student-to-course-modal/ListStudentAddedToCourseModal";
import ConditionRegister from "./condition-register";
import "./index.scss";
import InfoAuthor from "./info-author";

const validate = {
  linkInvite: {
    required: true,
    message: "Vui lòng nhập địa chỉ URL",
  },
  nameLayout: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (isEmpty(value)) {
        return Promise.reject(new Error("Vui lòng nhập tên bố cục"));
      }
      if (value.length > 255) {
        return Promise.reject(new Error("Tên bố cục không vượt quá 255 ký tự"));
      }
      return Promise.resolve();
    },
  },
};

type SettingContentCourseProps = {
  form: FormInstance;
  dataSetting?: any;
  isCertificate?: boolean;
  certificateId?: number;
  courseId?: string;
  setIsCertificate: (value: boolean) => void;
  setCertificateId: (value: number) => void;
  resetForm?: () => void
};
interface StudentImport {
  userId: number,
  email: string
}
const SettingContentCourse = ({
  form,
  dataSetting,
  resetForm
}: SettingContentCourseProps) => {
  const { t } = useTranslation();
  const { id } = useParams()
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [optionCourses, setOptionCourses] = useState([])
  const accessToken = useAuthStore((state) => state.accessToken);
  const [totalRecords, setTotalRecords] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const [loadingUpload, setLoadingUpload] = useState<any>(false);
  const [uploadedImages, setUploadedImages] = useState<any>(
    {}
  );
  const [dataImagesName, setDataImagesName] = useState<any>(
    {}
  );
  const [isAddStudent, setIsAddStudent] = useState<boolean>(false)
  const [openImportModal, setOpenImportModal] = useState(false);
  const [openListStudentAdded, setOpenListStudentAdded] = useState<boolean>(false)
  const [studentListImport, setStudentListImport] = useState<StudentImport[]>([])
  const [loadingConfirm, setLoadingConfirm] = useState<any>(false);
  const hasEnrollClass = get(dataSetting, 'isScheduleByTeacher');

  type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

  const newCourseRegister = optionCourses.map((i: any) => ({
    label: i.name,
    code: i.code,
  }))

  const getDataCourse = async (page = 1) => {
    setLoading(true)
    postCourseSearch({ pageSize: 0, pageNumber: pageNumber, status: [13] })
      .then(res => {
        const { data, totalRecords } = res.data.data;
        setOptionCourses(data.filter((data: any) => data.status === 13));
        setTotalRecords(totalRecords);
        setPageNumber(page)
        setLoading(false)
        if (data.length < 10) {
          setHasMore(true)
        } else {
          setHasMore(false)
        }
      }).catch((err) => {
      })
  }

  const handleAddStudent = () => {
    setIsAddStudent(!isAddStudent)
  }

  useEffect(() => {
    getDataCourse();
  }, []);

  useEffect(() => {
    if (dataSetting?.image && !form.getFieldValue("imageAvatar")) {
      const imagePath = dataSetting.image.split("cdn?path=")[1];
      form.setFieldsValue({
        imageAvatar: imagePath,
      });
    }
  }, [dataSetting, form]);

  const beforeUpload = (file: FileType) => {
    setLoadingUpload(true);
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 4;

    if (!isJpgOrPng) {
      message.error(t("Ảnh yêu cầu định dạng jpeg/png!", "Ảnh yêu cầu định dạng jpeg/png!"));
      setTimeout(() => {
        setLoadingUpload(false);
      }, 300)
    }
    if (!isLt2M) {
      message.error(t("Ảnh phải có dung lượng nhỏ hơn 4M!", "Ảnh phải có dung lượng nhỏ hơn 4M!"));
      setTimeout(() => {
        setLoadingUpload(false);
      }, 300)
    }

    return isJpgOrPng && isLt2M;
  };

  const handleChangeImage = (info: any) => {
    if (info.file.status === 'uploading') {
      setLoadingUpload(true);
      return;
    }

    if (info.file.status === 'done') {
      message.success(t("Tải ảnh lên thành công !", "Tải ảnh lên thành công !"));
      setLoadingUpload(false);
      const { response } = info.file;

      if (response && response.filePath && form) {
        const { response } = info.file
        setUploadedImages({
          ...uploadedImages,
          images: response.fileName
        });
        setDataImagesName({
          ...dataImagesName,
          images: response.filePath
        })

        form.setFieldsValue({
          imageAvatar: response.fileName
        })
      }
    }
  };


  const handleRemoveImage = (e: MouseEvent) => {
    e.preventDefault();
    setDataImagesName({
      ...dataImagesName,
      images: null
    })
    setUploadedImages({
      ...uploadedImages,
      images: null
    })
    if (dataSetting.image) {
      dataSetting.image = null
    }
  };

  const downloadTemplate = async () => {
    await downloadTemplateExportStudentToCourse(Number(id)).then((res) => {
      if (res.status === 200) {
        handleExportExcel(res.data, "File mẫu.xlsx")
      }
    })
  }

  const handleConfirmAddStudentToCourse = async () => {
    setLoadingConfirm(true)
    try {
      await addStudentToCourseByExcel(Number(id), studentListImport);
      message.success(t("Thêm học viên thành công!", "Thêm học viên thành công!"));
      setTimeout(() => {
        setOpenListStudentAdded
      }, 0);
    } catch (error) {
      message.error(t("Đã xảy ra lỗi khi thêm học viên.", "Đã xảy ra lỗi khi thêm học viên."));
    }
    finally {
      setLoadingConfirm(false)
    }
  };

  const handleAddStudentToCourseByChoose = async (value: any) => {
    setLoadingConfirm(true)
    try {
      const payload = {
        courseId: id,
        userIds: value.listStudent
      }

      await addStudentToCourseByChoose(payload);
      message.success(t("Thêm học viên thành công!", "Thêm học viên thành công!"));
      setTimeout(() => {
        setIsAddStudent(false)
      }, 0);
    } catch (error) {
      message.error(t("Đã xảy ra lỗi khi thêm học viên.", "Đã xảy ra lỗi khi thêm học viên."));
    }
    finally {
      setLoadingConfirm(false)
    }
  };

  return (
    <>
      <div className="general-settings">
        <section className="setting-course">
          <div className="form-settings">
            <CustomCard
              title={t("Thông tin chung", "Thông tin chung")}
              className="wrapper-settings--card form-setting--general"
            >
              <div className="link-invite">
                <Form.Item
                  name="url"
                  rules={[validate.linkInvite]}
                  label="URL"
                >
                  <FormItemInput
                    prefixIcon="https://"
                    readOnly={true}
                    suffix={
                      <Tooltip
                        title={t("Sao chép thành công!", "Sao chép thành công!")}
                        trigger="click"
                      >
                        <CopyOutlined
                          style={{ color: "rgba(0, 0, 0, 0.25)" }}
                          onClick={() => {
                            navigator.clipboard.writeText(dataSetting.url);
                          }}
                        />{" "}
                      </Tooltip>
                    }
                  />
                </Form.Item>

                {!hasEnrollClass &&
                  <> <Button
                    className="btn"
                    onClick={handleAddStudent}
                  >
                    <PlusOutlined />
                    <Typography.Text>{t("Thêm", "Thêm")}</Typography.Text>
                  </Button>
                    <Button
                      className="btn"
                      onClick={() => setOpenImportModal(true)}
                    >
                      <UploadOutlined />
                      <Typography.Text>Import</Typography.Text>
                    </Button></>}

              </div>
              <Form.Item
                name="layoutName"
                rules={[validate.nameLayout]}
                label={t("Tên bố cục", "Tên bố cục")}
              >
                <FormItemInput placeholder={t("Nhâp tên bố cục", "Nhâp tên bố cục")} />
              </Form.Item>
              <Form.Item
                name="imageAvatar"
                label={t("Ảnh đại diện", "Ảnh đại diện")}
                className="upload--avatar"
              >
                <div className="image-container">
                  <Upload
                    listType="picture-card"
                    className="upload-image--settings"
                    action={
                      BASE_URL_V2 +
                      "/mooc-course-block-quiz/upload-file"
                    }
                    headers={{
                      Authorization:
                        "Bearer " + accessToken,
                    }}
                    beforeUpload={beforeUpload}
                    onChange={(e) =>
                      handleChangeImage(e)
                    }
                    showUploadList={false}
                  >
                    {
                      loadingUpload ? (
                        <div className='upload-content'><LoadingOutlined /></div>
                      ) : (
                        (dataSetting.image || dataImagesName.images) ? (
                          <img className='image-present'
                            src={dataSetting?.image ? dataSetting?.image : dataImagesName.images}
                            style={{
                              width: "100%",
                              height: "100%",
                            }}

                            alt='image' />

                        ) : (
                          <div className='upload-content'><PlusOutlined /><span>{t("Tải lên", "Tải lên")}</span></div>
                        )
                      )
                    }
                  </Upload>
                  {(dataSetting.image || dataImagesName.images) && <span className="remove-icon">
                    <a className="upload-action" onClick={(e) => handleRemoveImage(e)}>
                      <DeleteOutlined />
                    </a>
                  </span>}
                </div>
                <div className="note-update">
                  <Typography.Text className="sub-title">
                    Độ phân giải đề xuất của ảnh khi tải
                    lên là 640*640, kích thước file tối đa
                    4MB.
                  </Typography.Text>
                </div>
              </Form.Item>

              {!hasEnrollClass && <div>
                {t("Danh sách học viên:", "Danh sách học viên:")}{" "}
                <a
                  href={`${routesConfig.courseManagement}/${id}/${routesConfig.courseStudentList}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary"
                >
                  {t("Học viên", "Học viên")}
                </a>
              </div>}
            </CustomCard>
            <ConditionRegister formInstance={form} dataConfig={dataSetting} loading={loading}
              fetchData={getDataCourse}
              pageNumber={pageNumber}
              hasMore={hasMore}
              totalRecords={totalRecords} optionCourses={newCourseRegister} />
            {/*<Certificate setIsCertificate={setIsCertificate}/>*/}
            <InfoAuthor form={form} dataConfig={dataSetting} />

            <div className="group-button">
              <Button
                className="ant-btn-primary"
                onClick={() => form?.submit()}
              >
                <SaveOutlined />
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
              <Button className="cancel-btn" onClick={resetForm}>
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
            </div>
          </div>
        </section>

        <AddStudentToCourseDrawer
          open={isAddStudent}
          handleClose={() => setIsAddStudent(!isAddStudent)
          }
          apiUrl={getListStudentAddEnrolled}
          onSubmit={(value) => handleAddStudentToCourseByChoose(value)}
          loadingConfirm={loadingConfirm}
        />

        <ImportStudentToCourseModal
          open={openImportModal}
          onClose={() => setOpenImportModal(false)}
          uploadApi={async (formData) => {
            try {
              const res = await importStudentToCourse(formData);
              setStudentListImport(res.data.data)
            } catch (error) {
            }
          }}
          onDownloadTemplate={downloadTemplate}
          onConfirmSuccess={() => {

            setOpenListStudentAdded(true)
          }}
          title={t("Import học viên vào khoá học", "Import học viên vào khoá học")}
        />
        <ListStudentAddedToCourseModal
          open={openListStudentAdded}
          onClose={() => setOpenListStudentAdded(false)}
          students={studentListImport}
          onConfirmSuccess={handleConfirmAddStudentToCourse}
          loadingConfirm={loadingConfirm}
        />
      </div>
    </>
  );
};

export default SettingContentCourse;
